import { useEffect, useRef } from 'react';

import { setCurrentAccountId } from '@/store/account/zustand-account-storage';
import { useAccountState } from '@/contexts/account/account-context';
import {
  useAttributionTableColumnsStore,
  useEventsAttributionTableColumnsStore,
} from '@/features/attribution/stores/attribution-table-columns-store';
import { useEcommerceTableColumnsStore } from '@/store/tables/ecommerce-table-columns-store';
import { usePnlTableColumnsStore } from '@/features/dashboard/stores/use-pnl-table-columns-store';

export function useTableColumnsAccountSync(viewId?: string): void {
  // viewId parameter is deprecated and ignored
  void viewId;
  
  const previousAccountId = useRef<string | null>(null);
  const { currentAccount } = useAccountState();
  const accountId = currentAccount?.id ?? null;

  useEffect(() => {
    if (previousAccountId.current === accountId) {
      return;
    }

    previousAccountId.current = accountId;
    
    // Update the shared storage adapter's account ID
    setCurrentAccountId(accountId);

    // Trigger rehydration on all table column stores
    // This loads the new account's column preferences from localStorage
    void useAttributionTableColumnsStore.persist.rehydrate();
    void useEventsAttributionTableColumnsStore.persist.rehydrate();
    void useEcommerceTableColumnsStore.persist.rehydrate();
    void usePnlTableColumnsStore.persist.rehydrate();
  }, [accountId]);
}
